import { FormattedCurrency } from '@iwIntlProvider/FormattedCurrency';
import { GetStatementsResponse } from '@iwoca/lapi-client/edge';
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow
} from '@ui';
import { FormattedDate, FormattedMessage } from 'react-intl';

const parseTransactionNumber = (number: number) =>
    number ? Math.abs(number) : 0;

export const AccountStatementTable = ({
    accountStatement
}: {
    accountStatement: GetStatementsResponse['data'][number];
}) => {
    const productType = accountStatement.product_type;
    const statementsWithMostRecentFirst = [
        ...accountStatement.statements!
    ].reverse();

    return (
        <Table data-testid="account-statement-table">
            <TableHeader>
                <TableRow>
                    <TableHead>
                        <FormattedMessage
                            id="_.account_history_table.date"
                            defaultMessage="Date"
                        />
                    </TableHead>
                    <TableHead />
                    {productType !== 'merchant_cash_advance' && (
                        <>
                            <TableHead>
                                <FormattedMessage
                                    id="_.account_history_table.principal"
                                    defaultMessage="Principal"
                                />
                            </TableHead>
                            <TableHead>
                                <FormattedMessage
                                    id="_.account_history_table.interest"
                                    defaultMessage="Interest / Fees"
                                />
                            </TableHead>
                        </>
                    )}
                    <TableHead>
                        <FormattedMessage
                            id="_.account_history_table.balance"
                            defaultMessage="Closing Balance"
                        />
                    </TableHead>
                </TableRow>
            </TableHeader>
            <TableBody>
                {statementsWithMostRecentFirst.map((statement, index) => (
                    <TableRow key={index}>
                        <TableCell>
                            <FormattedDate
                                day="numeric"
                                month="short"
                                year="numeric"
                                value={new Date(statement.date!)}
                            />
                        </TableCell>
                        <TableCell>{statement.description}</TableCell>
                        {productType !== 'merchant_cash_advance' && (
                            <>
                                <TableCell>
                                    <FormattedCurrency
                                        value={parseTransactionNumber(
                                            statement.transaction_principal!
                                        )}
                                    />
                                </TableCell>
                                <TableCell>
                                    <FormattedCurrency
                                        value={
                                            parseTransactionNumber(
                                                statement.transaction_interest!
                                            ) +
                                            parseTransactionNumber(
                                                statement.transaction_fees!
                                            )
                                        }
                                    />
                                </TableCell>
                            </>
                        )}
                        <TableCell>
                            <FormattedCurrency
                                value={statement.closing_balance}
                            />
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
};
